export default "__VITE_ASSET__CFGAjYO3__"